export const StorageKeys = {
  OMIT_ONBOARDING: 'omitOnboarding',
};

export const FeatureFlags = {
  ThrottlingEnabled: false,
};

export const THROTTLE_MS = 2000;

export const MAX_FILE_SIZE_BYTES = 200_000_000; // 20 MB

export const NO_PAGINATION_PAGE_SIZE = 1000;

export const MAX_NUMBER_OF_LOADING_SKELETONS = 10;

export const COMBOBOX_MAX_OPTIONS_SHOW_ALL = 1000;

export enum MenuItemType {
  LINK = 'link',
  DROPDOWN = 'dropdown',
  BUTTON = 'button',
}

export const DEFAULT_COUNTRY = {
  country_code: '+49',
  subdivision_code: 'DE',
};
